<div class="h-full min-w-0 flex flex-col justify-start items-stretch overflow-hidden space-y-4">
    <!-- Header -->
    <div class="flex-0 flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div class="flex flex-1 min-w-0 flex-row items-center justify-start gap-x-4 sm:gap-x-6">
            <button (click)="goBack()" type="button" class="fab-button-secondary shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="min-w-0 w-full flex-1 flex flex-row items-center justify-between gap-x-2 gap-y-1">
                <scr-screen-band class="w-full" />

                <scr-screening-tabs [tabs]="tabs()" [activeId]="selectedTab()" ariaLabel="Screening brief sections"
                    (tabSelect)="selectTab($event)" />

                <div class="hidden h-8 border border-gray-200 dark:border-gray-700 rounded-md sm:block"></div>

                <button (click)="requestAddCreators()" type="button"
                    class="inline-flex shrink-0 flex-nowrap items-center gap-x-1.5 whitespace-nowrap rounded-md primary-go-button">
                    Add Creators
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="-mr-0.5 size-5">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <line x1="19" x2="19" y1="8" y2="14" />
                        <line x1="22" x2="16" y1="11" y2="11" />
                    </svg>
                </button>

                <button type="button" class="fab-button-secondary">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path
                            d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                        <path d="M12 18v-6" />
                        <path d="m9 15 3 3 3-3" />
                    </svg>
                </button>
            </div>
        </div>

    </div>
    <!-- Header - END -->


    <!-- Main Tabbed Section -->
    <div class="mbt-tab-panel flex h-full min-h-0 w-full flex-1 flex-col gap-y-4 overflow-hidden">

        @if (results.briefState() === 'error') {
        <p class="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground" role="alert">
            We couldn't load this screening brief. Try refreshing, or go back and open it again.
        </p>
        } @else {

        <div class="flex min-h-0 flex-1 flex-col gap-y-4 overflow-hidden">
            <div class="flex h-full min-h-0 flex-col gap-y-4 overflow-hidden">
                <div class="w-full shrink-0">
                    <scr-screen-kpis />
                </div>
                <div class="flex min-h-0 flex-1 flex-col gap-y-4 overflow-hidden">
                    <div class="flex h-full min-h-0 flex-col overflow-hidden">

                        <p class="sr-only" role="status" aria-live="polite">{{ panelAnnouncement() }}</p>

                        <div role="tabpanel" [id]="'scr-panel-' + selectedTab()"
                            [attr.aria-labelledby]="'scr-tab-' + selectedTab()" tabindex="0"
                            class="scr-panel flex min-h-0 flex-1 flex-col overflow-hidden focus-visible:outline-none">
                            @switch (selectedTab()) {
                            @case ('brief_management') {
                            <scr-screen-brief-management class="block h-full min-h-0 flex-1 overflow-hidden" />
                            }
                            @case ('content') {
                            <scr-screen-content class="block h-full min-h-0 flex-1 overflow-hidden" />
                            }
                            @case ('creators') {
                            <div class="h-full min-h-0 flex-1 overflow-hidden">
                                <scr-screen-creators [focussedScreeningBriefId]="results.briefId() ?? ''" />
                            </div>
                            }
                            }
                        </div>

                    </div>
                </div>
            </div>



        </div>
        }

    </div>
    <!-- Main Tabbed Section - END -->
</div>




<!-- <div class="flex h-full w-full flex-col items-center justify-start overflow-hidden">

    <div class="h-full w-full overflow-y-auto">
        <div class="mx-auto flex max-w-[1240px] flex-col gap-6 px-4 pb-16 sm:px-8">

            <div class="flex items-start gap-4 pt-1">
                <button (click)="goBack()" type="button" class="fab-button-secondary mt-1 shrink-0"
                    aria-label="Back to briefs">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5" aria-hidden="true">
                        <path d="m12 19-7-7 7-7" />
                        <path d="M19 12H5" />
                    </svg>
                </button>

                <div class="min-w-0 flex-1">
                    <scr-screen-band (addCreators)="requestAddCreators()" />
                </div>
            </div>

            @if (results.briefState() === 'error') {
            <p class="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground" role="alert">
                We couldn't load this screening brief. Try refreshing, or go back and open it again.
            </p>
            } @else {

            <scr-screen-kpis />

            <scr-screening-tabs [tabs]="tabs()" [activeId]="selectedTab()" ariaLabel="Screening brief sections"
                (tabSelect)="selectTab($event)" />

            <p class="sr-only" role="status" aria-live="polite">{{ panelAnnouncement() }}</p>

            <div role="tabpanel" [id]="'scr-panel-' + selectedTab()" [attr.aria-labelledby]="'scr-tab-' + selectedTab()"
                tabindex="0" class="scr-panel focus-visible:outline-none">
                @switch (selectedTab()) {
                @case ('brief_management') {
                <scr-screen-brief-management />
                }
                @case ('content') {
                <scr-screen-content />
                }
                @case ('creators') {
                <scr-screen-creators [focussedScreeningBriefId]="results.briefId() ?? ''" />
                }
                }
            </div>
            }
        </div>
    </div>
</div> -->